module.exports = __webpack_public_path__ + "static/media/zoom-plus.e8f2ca85.svg";